import { ApiConfig } from "@/config/api/types";
import { authHeader } from "@/config/api/headers";

export enum ServiceRecordsApiEndpoints {
  GET_SUPPLIER_SERVICE_RECORDS = "getSupplierServiceRecords",
  CREATE_SERVICE_RECORD = "createServiceRecord",
  UPDATE_SERVICE_RECORD = "updateServiceRecord",
  MARK_SERVICE_RECORD_COMPLETE = "markServiceRecordComplete",
  DELETE_SERVICE_RECORD = "deleteServiceRecord",
  CREATE_DOCUMENTATION = "createDocumentation",
}

export const ServiceRecordsApi: ApiConfig = {
  baseUri: import.meta.env.VITE_APP_BASE_URI || "",
  contextPath: "/ServiceRecord",
  headers: [authHeader],
  endpoints: [
    {
      key: Symbol.for(ServiceRecordsApiEndpoints.GET_SUPPLIER_SERVICE_RECORDS),
      method: "GET",
      url: "",
      description: "Get service records for supplier and offer",
    },
    {
      key: Symbol.for(ServiceRecordsApiEndpoints.CREATE_SERVICE_RECORD),
      method: "POST",
      url: "",
      description: "Create a new service record",
    },
    {
      key: Symbol.for(ServiceRecordsApiEndpoints.UPDATE_SERVICE_RECORD),
      method: "PUT",
      url: "",
      description: "Update an existing service record",
    },
    {
      key: Symbol.for(ServiceRecordsApiEndpoints.MARK_SERVICE_RECORD_COMPLETE),
      method: "PATCH",
      url: "",
      description: "Mark service record as complete",
    },
    {
      key: Symbol.for(ServiceRecordsApiEndpoints.DELETE_SERVICE_RECORD),
      method: "DELETE",
      url: "",
      description: "Delete a service record",
    },
  ],
};

export const DocumentationApi: ApiConfig = {
  baseUri: import.meta.env.VITE_APP_BASE_URI || "",
  contextPath: "/Tender",
  headers: [authHeader],
  endpoints: [
    {
      key: Symbol.for(ServiceRecordsApiEndpoints.CREATE_DOCUMENTATION),
      method: "POST",
      url: "",
      description: "Create documentation attachments",
    },
  ],
};
